import React, { useState } from 'react'

import { Button } from '@material-ui/core'
import { Plus as PlusIcon } from 'react-feather'

import { Permitted } from 'components'
import AddCategoryDialog from '../AddCategoryDialog'

import constants from 'constants/index'

const AddCategoryButton = ({ onSuccess }) => {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Permitted tag={constants.permissions.COMPLAINTS.MANAGE_CONFIGURATIONS}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        startIcon={<PlusIcon size={16} />}
      >
        Adicionar
      </Button>
      <AddCategoryDialog
        open={open}
        onClose={handleClose}
        onSuccess={onSuccess}
      />
    </Permitted>
  )
}

export default AddCategoryButton
